import { isSuperAdmin } from '../../../utils/functions';

export function getSubAbas() {
  const abas = [
    { label: 'Lista de Usuários', rota: '/daf/adm/usuarios' },
    { label: 'Acessos', rota: '/daf/adm/acessos' },
    { label: 'Logs', rota: '/daf/adm/logs' },
  ];

  if (isSuperAdmin()) {
    abas.push(
      { label: 'Informes', rota: '/daf/adm/informes' },
      { label: 'Domínios', rota: '/daf/adm/dominios' },
      { label: 'Cores', rota: '/daf/adm/cores' },
      { label: 'Setores DAF', rota: '/daf/adm/setores' },
      { label: 'Módulos Sisaf', rota: '/daf/adm/modulossiaf' },
    );
  }
  abas.push({ label: 'Fluxos Administrativos', rota: '/daf/adm/fluxos-adm' });
  return abas;
}
